import { DetailBadge } from "@/features/ui/detail/DetailBadge";
import { DetailContent } from "@/features/ui/detail/DetailContent";
import { DetailField } from "@/features/ui/detail/DetailField";
import { DetailHeader } from "@/features/ui/detail/DetailHeader";
import { DetailInformTitle } from "@/features/ui/detail/DetailInformTitle";
import { DetailLabel } from "@/features/ui/detail/DetailLabel";
import { DetailLink } from "@/features/ui/detail/DetailLink";
import { DetailLinkWrapper } from "@/features/ui/detail/DetailLinkWrapper";
import { DetailTitle } from "@/features/ui/detail/DetailTitle";
import { useTranslation } from "react-i18next";

const DetailRouting = Object.assign(DetailHeader, {
  Title: DetailTitle,
  Inform: DetailInformTitle,
  Field: DetailField,
  Label: DetailLabel,
  Link: DetailLink,
  LinkWrapper: DetailLinkWrapper,
  Badge: DetailBadge,
  Content: DetailContent,
});

export const RoutingBomInform = () => {
  const { t } = useTranslation();
  return (
    <DetailRouting bg={"#FFFFFF"}>
      <DetailRouting.Title size={26}>
        {t("routing.routing")} {"BOM(Bill of Materials)"}
      </DetailRouting.Title>
      <DetailRouting.Inform>{t("routing.bomDescription")}</DetailRouting.Inform>
    </DetailRouting>
  );
};
